import { useDispatch, useSelector } from "react-redux";
import { getErrorMessage } from "../../../utils/errorUtils";
import logger from "../../../utils/logger";

const initialState = {
	pageProps: {
		nav: {
			dark: true,
			classes: "bg-hover-ready-orange bg-fixed-ready-orange navbar-hover-light navbar-fixed-light",
			color: "transparent",
			fixed: false,
			light: false,
			sticky: false
		},
		headerAbsolute: false,
		headerClasses: null,
		title: "ReadyRx",
		topbarContent: null,
		topbarBgVariant: 'ready-black',
		topbarTextVariant: 'white',
		loggedUser: null,
		hideTopbar: false,
		hideFooter: false,
		noPaddingBottom: false,
		navCTA: null,
		floatingCTA: null
	}
};

const layoutReducer = (state = initialState, action) => {
	const { type, payload } = action;
	switch (type) {
		case 'UPDATE_PAGE_PROPS':
			return {
				...state,
				pageProps: payload.pageProps
			};
		default:
			return state;
	}
};

export const setPageProps = (pageProps) => {
	return async (dispatch) => {
		try {
			dispatch({ type: 'UPDATE_PAGE_PROPS', payload: { pageProps: pageProps } });
		} catch (error) {
			logger.logReduxErrorEvent(error, getErrorMessage(error), true);
		}
	}
};

export const useLayout = () => {
	const dispatch = useDispatch();

	return {
		LayoutState: useSelector((appState) => appState.layoutState),

		pageProps: useSelector((appState) => appState.layoutState.pageProps),

		setPageProps: (pageProps) => dispatch(setPageProps(pageProps))
	};
};

export default layoutReducer;